import './polyfills'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import Pusher from './plugins/pusher'
import Functionality from './plugins/functionality'
import { helper } from './utils/helper'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

import { abilitiesPlugin } from '@casl/vue'
import ability from './utils/ability'

import fontawesomeComponent from './components/baseComponents/fontawesome'
import ADDFComponents from './components/addf-package/components'

import utils from './utils'
import './assets/tailwind.css'

import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import '@angelblanco/v-calendar/dist/style.css'
import prototype from './plugins/prototype'

import TransPlugin from '@/plugins/trans.plugin'

import mitt from 'mitt'
const emitter = mitt()

import { registerAllModules } from 'handsontable/registry'
registerAllModules()

const user = store.getters.getAuth

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_KEY,
  plugins: [new BugsnagPluginVue()],
  enabledReleaseStages: ['production', 'staging'],
  enabledBreadcrumbTypes: ['error', 'navigation', 'request', 'user'],
  appVersion: import.meta.env.VITE_APP_VERSION,
  releaseStage: import.meta.env.MODE,
  user: {
    id: user?.id,
    name: user?.full_name,
    email: user?.email
  }
})

const bugsnagVue = Bugsnag.getPlugin('vue')

i18n.setup()

const app = createApp(App)
  // .use(baseComponents)
  .use(i18n.vueI18n)
  .use(store)
  .use(router)
  .use(bugsnagVue)
  .use(VueScrollTo)
  .use(Pusher)
  .use(Functionality)
  .use(TransPlugin)
  .use(prototype)
  .use(abilitiesPlugin, ability, {
    useGlobalProperties: true
  })

ADDFComponents(app)
fontawesomeComponent(app)
utils(app)
helper.initBrand(app)

app.config.globalProperties.emitter = emitter

router.beforeEach(async (to, from, next) => {
  const code = to.query.impersonation_code

  if (!code) {
    return next()
  }

  try {
    await store.dispatch('impersonation/exchange', code)
  } catch (error) {
    console.error('Impersonation code exchange failed:', error)
  }

  const remainingQuery = { ...to.query }
  delete remainingQuery.impersonation_code

  return next({ path: to.path, query: remainingQuery, replace: true })
})

app.config.errorHandler = (err, instance, info) => {
  if (import.meta.env.PROD) {
    Bugsnag.notify(err)
  } else {
    helper.toastInfo(
      "Une erreur s'est produite. L'équipe support a été notifiée de cette erreur.",
      null,
      'toastErrorHandler'
    )
  }
  console.log(err)
  console.log(instance)
  console.log(info)
}

app.mount('#app')
